module.exports = __webpack_public_path__ + "img/y-244.31994723.png";